import { defineAction } from '~/prix'
import datasusCollectAction from './datasusCollect.action.json' with { type: 'json' }
import { z } from 'zod'

const datasusCollectDefinition = defineAction({
  ...datasusCollectAction,

  input: z.object({
    healthUnits: z.boolean().optional(),
    teams: z.boolean().optional(),
    sigtap: z.boolean().optional(),
    all: z.boolean().optional(),
  }),
  output: z.object({}),
})

export default datasusCollectDefinition
